import React, { useState, useEffect } from "react";
import { Mail} from "lucide-react";

const Contact = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768); // Tailwind md breakpoint
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <section className="bg-white pb-24">
      <div className="max-w-4xl mx-auto px-6 text-center">
        {/* Heading */}
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Contact <span className="text-red-600">Us</span>
        </h2>

        {/* Description */}
        <p className="text-gray-600 mb-12">
          If you have any query, feel free to discuss with our experts. 
          We assure best solution to your query.
        </p>

        {/* Contact Info */}
        <div className="space-y-8 text-left">
          {/* Email */}
          <div className="flex items-center gap-4">
            <Mail className="text-red-600 w-6 h-6" />
            <a
              href={
                isMobile
                  ? "mailto:corporate@nikalosafe.ai"
                  : "https://mail.google.com/mail/?view=cm&fs=1&to=corporate@nikalosafe.ai"
              }
              target={isMobile ? "_self" : "_blank"}
              rel="noopener noreferrer"
              className="text-gray-800 font-medium hover:underline"
            >
              corporate@nikalosafe.ai
            </a>
          </div>
          
          {/* Phone */}
     {/*   <div className="flex items-start gap-4">
            <Phone className="text-red-600 w-6 h-6 mt-1" />
            <div className="text-gray-800 font-medium">
              <a href="tel:+918390703746" className="flex items-center hover:text-gray-900 transition-colors cursor-pointer"><p>+918390703746</p></a>
              <a href="tel:+918329709173" className="flex items-center hover:text-gray-900 transition-colors cursor-pointer"><p>+918329709173</p></a> 
            </div>
          </div>    
    */} 
        </div>
      </div>
    </section>
  );
};

export default Contact;
